import { createEffect, untrack } from "solid-js"
import { Group, Mesh, type Object3D } from "three"
import type { Engine } from "../../core/engine/Engine.type"
import type { EntityGraphNode } from "../../core/engine/EntityGraphNode/EntityGraphNode.type"
import applyEntityRotationToNextObject3DFrame from "../../core/entity/EntityHeading/applyEntityRotationToNextObject3DFrame"
import applyEntityWalkPathToNextObject3DFrame from "../../core/entity/EntityHeading/applyEntityWalkPathToNextObject3DFrame"
import type { MediumTankEntity } from "../../core/entity/EntityType/MediumTank"
import shouldEntityShowFadedFrames from "../../core/entity/shouldEntityShowFadedFrames"
import tmpRng from "../../core/rng/tmpRng"
import { mountOnFrameUpdateToObject3D } from "../../event/GameObject3D/GameObject3DFrameUpdate/GameObject3DFrameUpdate"
import assertClassInDev from "../../ldsh/assertClassInDev"
import { M1Abrams1_M1Abrams1_GLTF_Model } from "../gltf_models.generated"
import { appGltfLoader } from "./appGltfLoader"
import applyPlayerColors from "./applyPlayerColors"
import creaseGeometryNormalsByMeshNameList from "./creaseGeometryNormalsByMeshNameList"
import cubicEaseInOutBounce from "./cubicEaseInOutBounce"
import runWithObject3DOwner from "./runWithObject3DOwner"

const totalLoopMs = 1000

const creaseMeshes = [
  'Cannon',
  'CannonJacket',
]

export default function makeMediumTankScene (
  engine: Engine,
  ent: EntityGraphNode<MediumTankEntity>,
  callback: (newGroup: Object3D) => void
): void {
  return appGltfLoader.load(M1Abrams1_M1Abrams1_GLTF_Model, function (ModelObj) {
    tmpRng.seed = ent.id
    const { scene } = ModelObj
    // printObjectHierarchy(scene)
    
    // scene.scale.multiplyScalar(scale)

    // console.log('rootScene', rootScene)

    const bodyGroup = scene.getObjectByName('Body') as Group
    assertClassInDev(bodyGroup, Group)

    // Cannon 120mm // but CannonBase would be used for up/down
    // const mainCannonMesh = scene.getObjectByName('Cannon') as Mesh
    // assertClassInDev(mainCannonMesh, Mesh)
    // creaseMeshGeometryNormals(mainCannonMesh)

    // M2 Browning
    const gunMesh = scene.getObjectByName('Gun') as Mesh
    assertClassInDev(gunMesh, Mesh)

    const turretGroup = scene.getObjectByName('Turret') as Group
    assertClassInDev(turretGroup, Group)

    const defaultBodyY = bodyGroup.position.y
    // const defaultTurretY = turretGroup.position.y
    // const defaultGun2Y = gunMesh.position.y

    let entValue = untrack(ent.raw)
    runWithObject3DOwner(scene, () => {
      createEffect(() => {
        entValue = ent.raw()
      })
    })

    mountOnFrameUpdateToObject3D(engine, bodyGroup, (elapsedMs: number, frameAt: number): void => {
      const mod = frameAt % totalLoopMs
      if (shouldEntityShowFadedFrames(entValue)) {
        bodyGroup.position.y = defaultBodyY
        // turretGroup.position.y = defaultTurretY
        // gunMesh.position.y = defaultGun2Y
      } else if (entValue.player_id) {
        const bounceOffset =  (cubicEaseInOutBounce(mod / 500) / 7)
        bodyGroup.position.y = defaultBodyY + bounceOffset
        // turretGroup.position.y = defaultTurretY + bounceOffset
        // gunMesh.position.y = defaultGun2Y + bounceOffset
      }
      applyEntityRotationToNextObject3DFrame(scene, elapsedMs)
      applyEntityWalkPathToNextObject3DFrame(scene, elapsedMs)
    })

    applyPlayerColors(engine, scene, ent)

    creaseGeometryNormalsByMeshNameList(scene, creaseMeshes)

    callback(scene)
  })
}
